( function(AUFHAUSEN) {
    var IMAGE_ATTR = 'data-image-src';
    var LOADED_CLASS = 'loaded';

    /**
     * create a global intersection observer, once widgets have loaded and set up event listeners
     * they can register for events through this observer
     */
    var GlobalIntersectionObserver = new IntersectionObserver( function( elementsToActivate ) {
        var activationEvent = new Event( 'event/activate' );
        elementsToActivate.forEach( function( element ) {
            if ( element.isIntersecting ) {
                element.target.dispatchEvent( activationEvent );
                GlobalIntersectionObserver.unobserve( element.target );
            }
        } );
    }, {
        root: null, // default to browser viewport
        rootMargin: '0px',
        threshold: 0.1
    } );

    /**
     * Given a picture element lazy load the srcset and the img tag when the element
     * comes into view with a nice animation
     * @param  {HTMLPictureElement} pictureElement the picture element
     * @constructor
     */
    AUFHAUSEN.LazyPictureElement = function( pictureElement ) {
        var _self = this;

        if (!pictureElement) {
            return;
        }

        _self.pictureElement = pictureElement;
        _self.mainImage = _self.pictureElement.querySelector( 'img' );

        if ( !_self.mainImage ) {
            return;
        }

        _self.sourceElements = [].slice.call( _self.pictureElement.querySelectorAll( 'source' ) );
        GlobalIntersectionObserver.observe( _self.pictureElement );
        _self.pictureElement.addEventListener( 'event/activate', _self.onPictureActivated.bind( _self ) );
    };

    /**
     * callback invoked when a picture element comes into view
     */
    AUFHAUSEN.LazyPictureElement.prototype.onPictureActivated = function() {
        var _self = this;

        _self.sourceElements.forEach( function( sourceElement ) {
            sourceElement.setAttribute( 'srcset', sourceElement.getAttribute( IMAGE_ATTR ) );
        } );

        _self.mainImage.setAttribute( 'src', _self.mainImage.getAttribute( IMAGE_ATTR ) );
        _self.mainImage.onload = function() {
            _self.pictureElement.classList.add( LOADED_CLASS );
        };
    };

} (AUFHAUSEN));
